import styled from 'styled-components';

export const SearchWrapper = styled.div`
  padding-top: 32px;
`;
